export * from './modal.module';
export * from './modal.component';
